import { Box, Button, IconButton, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { AddCircleOutline, ArrowBack, ArrowForward, Check, Clear, FilterAlt, LocalParking, North,South } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { VisitorParkingRequest } from "../../Types/UnitFeatureTypes";
import { useDispatch, useSelector } from "react-redux";
import { Actions, RootState } from "../../Redux/Reducer/rootReducer";
import { FIXED_PAGE_ROWS } from "../../Utils/Constants";
import { fetchVisitorParking, fetchVisitorParkingCount } from "../../Redux/selectors";
import BuildVisitorParkingTable from "../BuildTables/BuildVisitorParkingTable";
import LoadingOverlay from "../CommonComponents/LoadingOverlay";
import SortComponent from "../CommonComponents/SortComponent";
import PageNavigation from "../CommonComponents/PageNavigation";
import ViewTableHeader from "../CommonComponents/ViewTableHeader";

const ViewVisitorParkingTable: React.FC = () => {

    const navigate = useNavigate();
    const [sortDirection, setSortDirection] = useState<boolean>(false);
    const [sortColumn, setSortColumn] = useState<string>('created_on');
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(1);
    const allVisitorParkingCount = useSelector(fetchVisitorParkingCount);
    const allVisitorParking = useSelector(fetchVisitorParking);
    const [item, setItem] = useState<VisitorParkingRequest[]>([]);
    const isLoading = useSelector((state: RootState) => state.fetchVisitorParking.request.loading);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(Actions.fetchVisitorParking.visitorParkingActions.request({offset: (currentPage)*FIXED_PAGE_ROWS, sortColumn, sortDirection: sortDirection ? 'asc' : 'desc'}));
        setTotalPages(Math.ceil(Number(allVisitorParkingCount)/FIXED_PAGE_ROWS));
    },[currentPage, allVisitorParkingCount, sortDirection, sortColumn]);

    useEffect(() => {
        if (allVisitorParking) {
            setItem(allVisitorParking);
        }
    }, [allVisitorParking]);

    const handleAddVisitorParking = (event: React.MouseEvent<HTMLButtonElement>) => {
        navigate('/requestVisitorParking');
    }

    return (
        <>
        <LoadingOverlay isLoading={isLoading} />
        <Paper elevation={5} sx={{mb: 2, padding: 3, borderRadius: 3}}>
            <ViewTableHeader
                title="Visitor Parking"
                icon={LocalParking}
                handleAdd={handleAddVisitorParking}
                addText="Add Visitor Parking"
                sortColumn={sortColumn}
                setSortColumn={setSortColumn}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                sortValues={[
                    { value: 'parking_start', label: 'Parking Start'},
                    { value: 'parking_end', label: 'Parking End'},
                    { value: 'created_on', label: 'Create Date'},
                    { value: 'unit', label: 'Unit'},
                    { value: 'status', label: 'Status'},
                ]}
            />
            <BuildVisitorParkingTable item={item} />
            <PageNavigation
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
            />
        </Paper>
        </>
    )
}

export default ViewVisitorParkingTable;